import type { GlobalFilter } from '@/types';
import {
  showsAndDateFromGlobalFilters,
  type ScopedContentPostLaunchComparison,
} from '../DownloadDrawer/downloadDrawerUtils';
import type { ScopedContentPerformanceDownloadSettings } from './contentPerformanceDownloadDrawer.d';

export const LAUNCH_WINDOW_OPTIONS: { label: string; value: ScopedContentPostLaunchComparison }[] =
  [
    { label: 'First 7 days', value: '7-day' },
    { label: 'First 30 days', value: '30-day' },
  ];

/**
 * Seeds drawer settings from the page filters. An empty `selectedShows` means all shows
 * (same semantics as {@link FiltersMultiSelectEcho} on the main page).
 */
export const buildDefaultDownloadSettings = (
  globalFilters: GlobalFilter
): ScopedContentPerformanceDownloadSettings => ({
  ...showsAndDateFromGlobalFilters(globalFilters),
  launchWindows: [],
  groupBy: 'network',
  period: 'all',
});

/** Ranges over a year can only be downloaded at the total period, and not by episode. */
export const getEffectiveSettings = (
  settings: ScopedContentPerformanceDownloadSettings,
  isRangeRestricted: boolean
): ScopedContentPerformanceDownloadSettings =>
  isRangeRestricted
    ? {
        ...settings,
        period: 'all',
        groupBy: settings.groupBy === 'episode' ? 'show' : settings.groupBy,
      }
    : settings;
